// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34fVx","footer":"styles_footer__1cmIm","passCodeTooltip":"styles_passCodeTooltip__1eGaz"};